// @flow
import React, { Component } from 'react';
import { StyleSheet, View } from 'react-native';
import theme from '../../../theme-config';
import { ActivityIndicator, Button, Text } from 'trpc-react-native-ui';

export default class PanelFullButton extends Component<Props> {
  styles = getStyles();

  render() {
    const styles = this.styles;
    const { text, style, disabled, isLoading, ...rest } = this.props;

    return (
      <Button {...rest} disabled={disabled}>
        <View style={[styles.button, style]}>
          {isLoading ? (
            <ActivityIndicator color={theme.overSecondaryColor} />
          ) : (
            <Text style={styles.buttonText}>{text}</Text>
          )}
        </View>
      </Button>
    );
  }
}

type Props = {
  text: string,
  style?: any,
  isLoading?: boolean,
  disabled?: boolean,
};

const getStyles = () =>
  StyleSheet.create({
    button: {
      backgroundColor: theme.secondaryColor,
      height: 45,
      alignItems: 'center',
      justifyContent: 'center',
      marginLeft: 3,
      marginRight: 3,
    },
    buttonText: {
      color: theme.overSecondaryColor,
      fontSize: 16,
      textAlign: 'center',
    },
  });
